import React from "react";
import {
  Image,
  Linking,
  ScrollView,
  StyleSheet,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import Text from "@components/CustomText";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";
import testIds from "@constants/testIds";
import t from "@constants/localization";
import OrderStatus from "../../../assets/svg/OrderStatus";

const PATH = "screens/OtherOrdersList/index";

export const showLimitedImages = (imgs = [], limit = 3) => {
  if (!imgs.length || limit <= 0) {
    return;
  }
  const totalImages = imgs.length;
  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <>
      {toShowOnlyArr.map((imageUrl, imageIndex) => (
        <Image
          resizeMode="contain"
          key={imageUrl}
          source={{ uri: imageUrl }}
          style={styles.image}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text variant="body_text_4" style={{ color: "rgba(0,0,0,0.56)" }}>
            +{+totalImages - limit}
          </Text>
        </View>
      )}
    </>
  );
};

const CommissionTag = ({ received }) => {
  if (received) {
    return (
      <View style={styles.commissionTag}>
        <OrderStatus
          orderStatus="OrderSuccessful"
          style={{ margin: 2 }}
          height={14}
          width={14}
        />
        <Text style={[styles.commissionTagText, { color: "#00AB59" }]}>
          {t("OrderList/orderCard/commission")}
        </Text>
      </View>
    );
  } else {
    return (
      <View style={styles.commissionTag}>
        <OrderStatus
          orderStatus="OrderCancelled"
          style={{ margin: 2 }}
          height={14}
          width={14}
        />
        <Text style={[styles.commissionTagText, { color: "#FF2E00" }]}>
          {t("OrderList/orderCard/commission")}
        </Text>
      </View>
    );
  }
};

const OrderCard = (props) => {
  const {
    item = {},
    navigateToDetails = () => {},
    showUserName = true,
    showPhone = true,
    index,
    onCancelOrder = () => {},
  } = props;

  const {
    // order_id = "",
    // created_at = "",
    num_items = 1,
    num_quantity = 1,
    images = [],
    user_name = "",
    user_phone = "",
    // payable_amount = "",
    payment_mode = "",
    // order_status = "",
    order_status_icon = "",
    order_status_color = "",
    order_rating = null,
    is_delivered_by_cmo: isDeliveredByCMO = false,
    is_commission_received: isCommissionReceived = true,

    order_id,
    order_status,
    created_at,
    payable_amount,
    juspay_order_id,
  } = item;

  const shouldAskForRating = order_status === "PAID";

  // eslint-disable-next-line no-shadow
  const cancelOrder = (juspay_order_id) => {
    onCancelOrder(juspay_order_id);
  };

  return (
    <View
      testID={`${testIds.order_no}${index}`}
      onPress={() => navigateToDetails(order_id, "FORWARD")}
      background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
    >
      <View
        style={[
          styles.orderCardContainer,
          { borderRadius: showUserName ? 0 : 10, paddingBottom: 15 },
        ]}
      >
        <View style={styles.topContainer}>
          <View style={styles.orderIdContainer}>
            <Text
              style={{
                fontSize: normalize(14),
                color: colors.lightBlack,
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {t("OrderList/orderCard/orderNo")}
              <Text
                style={{
                  fontFamily: "Mukta-SemiBold",
                  color: colors.black,
                  fontSize: normalize(14),
                }}
              >{`${order_id}`}</Text>
            </Text>
            <View
              style={{
                margin: 0,
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: normalize(12),
                  color: colors.lightBlack,
                  fontFamily: "NotoSansDevanagari-Regular",
                }}
              >
                {num_items} {t("OrderList/orderCard/items")} • {num_quantity}{" "}
                {t("OrderList/orderCard/qty")}
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-end",
              flex: 0.5,
              flexWrap: "wrap",
            }}
          >
            <Text
              style={{
                fontSize: normalize(14),
                color: colors.lightBlack,
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {t("OrderList/orderCard/orderDate")}
            </Text>
            <Text
              style={{
                color: colors.black,
                fontSize: normalize(14),
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {` ${created_at.trim()}`}
            </Text>
          </View>
        </View>

        <ScrollView horizontal contentContainerStyle={styles.imageContainer}>
          {images && showLimitedImages(images, 4)}
        </ScrollView>
        {showUserName && (
          <View style={styles.namePriceContainer}>
            <Text style={styles.namePriceText}>{user_name}</Text>
            <Text
              style={[
                styles.namePriceText,
                { fontFamily: "NotoSansDevanagari-Bold" },
              ]}
            >
              {payable_amount > 0 ? `₹${parseInt(payable_amount, 10)}` : ""}
            </Text>
          </View>
        )}

        {showPhone && (
          <View style={styles.phonePaymentContainer}>
            <TouchableOpacity
              testID="ooc-call-user"
              onPress={() =>
                Linking.openURL(`whatsapp://send?phone=+91${user_phone}`)
              }
            >
              <View>
                <Text
                  style={{
                    color: colors.lightBlack,
                    fontSize: 12,
                    lineHeight: 16,
                    fontFamily: "NotoSansDevanagari-Regular",
                  }}
                >
                  +91 - {user_phone}
                </Text>
              </View>
            </TouchableOpacity>
            <View>
              <Text
                style={{
                  color: "rgba(0, 0, 0, 0.56)",
                  fontFamily: "NotoSansDevanagari-Regular",
                  fontSize: 12,
                  lineHeight: 16,
                }}
              >
                {+payable_amount > 0 ? payment_mode : ""}
              </Text>
            </View>
          </View>
        )}

        <View style={styles.deliveryContainer}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <OrderStatus
              orderStatus={order_status_icon}
              style={{ marginRight: 6 }}
            />
            <Text
              style={{
                color: order_status_color,
                fontFamily: "NotoSansDevanagari-SemiBold",
                marginTop: 6,
              }}
            >
              {order_status}
            </Text>
            {isDeliveredByCMO && (
              <View
                style={{
                  flexDirection: "row",
                  marginHorizontal: 6,
                  marginTop: 4,
                  alignItems: "center",
                }}
              >
                <Text style={styles.deliveredByCMO}>
                  {t("OrderList/orderCard/deliveredByCMO")}
                </Text>
                <CommissionTag received={isCommissionReceived} />
              </View>
            )}
          </View>
        </View>
        <View style={styles.buttonsContainer}>
          {shouldAskForRating && (
            <TouchableOpacity
              testID="ooc-cancel-order"
              activeOpacity={1}
              style={[
                styles.waContainer,
                {
                  flexDirection: "row",
                  backgroundColor: "white",
                  paddingHorizontal: 15,
                  borderWidth: 1,
                  color:
                    order_rating === null
                      ? colors.darkBackground
                      : colors.white,
                },
              ]}
              onPress={() => {
                cancelOrder(juspay_order_id);
              }}
            >
              <Text
                style={{
                  color: "black",
                  marginLeft: 10,
                  fontSize: 14,
                  fontFamily: "NotoSansDevanagari-Bold",
                }}
              >
                {t(`${PATH}/cancelOrder`)}
              </Text>
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  orderCardContainer: {
    // backgroundColor: "red",
    flexDirection: "column",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginVertical: 5,
    backgroundColor: colors.white,
  },
  orderIdContainer: {
    flex: 0.5,
    // flexDirection: "row",
    // alignItems: "center",
  },
  topContainer: {
    // backgroundColor: "pink",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  imageContainer: {
    overflow: "visible",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingTop: normalize(12),
    paddingBottom: normalize(17),
  },
  image: {
    marginRight: 15,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
  },
  nMoreBox: {
    height: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  namePriceContainer: {
    // backgroundColor: "teal",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  namePriceText: {
    fontSize: normalize(16),
    fontFamily: "NotoSansDevanagari-SemiBold",
    color: colors.mediumBlack,
  },
  phonePaymentContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deliveryContainer: {
    flex: 1,
    paddingBottom: 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  buttonsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15,
  },
  waContainer: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.mediumBlack,
    paddingVertical: 8,
    alignItems: "center",
    justifyContent: "center",
  },

  deliveredByCMO: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 24,
    textAlign: "left",
    color: colors.primary,
  },
  commissionTag: {
    flexDirection: "row",
    backgroundColor: "background: rgba(0, 0, 0, 0.06)",
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 1,
    paddingRight: 6,
    marginHorizontal: 4,
  },
  commissionTagText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 12,
    fontWeight: "600",
    lineHeight: 18,
  },
});

export default OrderCard;
